import type { RouteObject } from "react-router";
import { KalenderAgentur, KalenderCreator } from "./Kalender";

/**
 * Kalender, Agentur und Creator. Gruppe „Kalender und Kennzahlen“.
 * Sprungziele (Glocke, Mail): /agentur/kalender?termin=<id>, /creator/kalender?termin=<id>, ?datum=YYYY-MM-DD, ?monat=YYYY-MM.
 */
export const kalenderAgenturRoutes: RouteObject[] = [
  { path: "kalender", element: <KalenderAgentur /> },
];

export const kalenderCreatorRoutes: RouteObject[] = [
  { path: "kalender", element: <KalenderCreator /> },
];
